<template>
    <div id="body_sub">
        <div class="box">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-4 p-2" v-for="store of stores">
                        <div class="block mx-3 p-4" @click="select(store.idi)">
                            <img class="d-block mb-2 mx-auto block-img" src="@/assets/img/shop.png" width="60">
                            {{ store.apelido }} - {{ store.cnpj }}
                        </div>
                    </div>
                    <div class="col-12 col-md-4 p-2" v-for="store of stores_app">
                        <div class="block_app mx-3 p-4" @click="select_app(store.idi)">
                            <img class="d-block mb-2 mx-auto block-img" src="@/assets/img/phone.png" width="60">
                            {{ store.apelido }}
                        </div>
                    </div>
                </div>
            </div>
            <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
        </div>
    </div>
</template>
<script>

import Loading from 'vue-loading-overlay';
import AuthService from '@/services/AuthService.js'
import {http} from '@/services/HttpService'
import ConfigService from '@/services/ConfigService'
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from 'moment'
export default {
    data() {
        return {
            error: false,
            isLoading: false,
            cnpj: undefined,
            password: undefined,
            image: './acompanhar.jpg',
            stores: [],
            stores_app: [],
        }
    },
    components: {
        Loading
    },
    methods: {
        select(idi){
            this.isLoading = true

            AuthService.selectIdi(idi)
                .then(res => {

                    Object.assign(http.defaults, {
                        headers: {
                            Authorization: 'bearer ' + localStorage.getItem('token'),
                            idi: idi
                        }
                    })

                    this.isLoading = false
                    localStorage.setItem('current_idi', idi)
                    localStorage.setItem('current_store', JSON.stringify(res.data))
                    localStorage.setItem("ultima_sinc", moment(res.data.ultima_conexao_ws).format('DD/MM/YY HH:mm:ss'))

                    //==================================================================================
                    // Chat
                    //==================================================================================
                    let interval = setInterval(() => {
                      try {
                        let token = localStorage.getItem('token')
                        let idi = localStorage.getItem('current_idi')
                        console.log("[DEBUG CHAT] Carregando dados da empresa no chat")


                        if(window.fcWidget && token && idi) {
                          let instalacao = JSON.parse(localStorage.getItem('stores')).find(x => x.idi == idi)

                          if(instalacao) {
                            console.log("[DEBUG CHAT] Setting information on fcWidget")

                            window.fcWidget.setExternalId(instalacao.idi);
                            window.fcWidget.user.setFirstName( "(" + instalacao.idi + ") DW - " + instalacao.apelido);
                            window.fcWidget.user.setEmail(instalacao.email);
                            window.fcWidget.user.setProperties({
                              plan: "Yooga App Web",                 // meta property 1
                              status: "Active"                // meta property 2
                            });

                            // window.fcWidget.open();

                            console.log("[DEBUG CHAT] Clearing Interval")
                            clearInterval(interval)
                          }
                        }
                      } catch(e) {
                        clearInterval(interval)
                        console.log(e)
                        console.log("[DEBUG CHAT] Falha crítica ao iniciar o chat")
                      }
                    }, 2000)

                    if(window.accessLevel == 100) {
                        ConfigService.fetch()
                        this.$router.replace("/fiscal")
                    } else {
                        this.$router.replace('/dashboard')
                    }


                })
                .catch(err => {
                    this.isLoading = false
                })
        },

        select_app(idi){
            this.isLoading = true

            AuthService.selectIdiApp({"idi":idi})
                .then(res => {
                    this.isLoading = false
                    // localStorage.setItem('current_idi', idi)
                    // localStorage.setItem('current_store', JSON.stringify(res.data))
                    // localStorage.setItem("app_token", res.data.token)
                    // localStorage.setItem("user", JSON.stringify(res.data.user))
                    
                    let contador = ''
                    if(window.accessLevel === 100) {
                      contador = '&user_contador=true'
                    }
                    
                    delete res.data.user.instalacao.certificado_base64
                    delete res.data.user.instalacao.marketplace_id
                    delete res.data.user.instalacao.marketplace_token
                    let user = res.data.user

                    user.nome = user.nome ? user.nome.replace("&", "e") : null
                    user.sobrenome = user.sobrenome ? user.sobrenome.replace("&", "e") : null
                    user.apelido = user.aplido ? user.apelido.replace("&", "e") : null

                    user.instalacao.apelido = user.instalacao.apelido ? user.instalacao.apelido.replace("&", "e") : null
                    user.instalacao.nome_fantasia = user.instalacao.nome_fantasia ? user.instalacao.nome_fantasia.replace("&", "e") : null
                    user.instalacao.razao_social = user.instalacao.razao_social ? user.instalacao.razao_social.replace("&", "e") : null

                    
                    let params = `?current_idi=${idi}&current_store=${JSON.stringify(res.data)}&app_token=${res.data.token}&user=${JSON.stringify(user)}` + contador

                    if(user.instalacao.modulo_emissor == 1){
                        window.location = process.env.VUE_APP_EMISSOR_URL + params
                    }else {
                        window.location = process.env.VUE_APP_DASHBOARD_APP_URL + params
                    }
                })
                .catch(err => {
                    console.error(err)
                    this.isLoading = false
                })
        }

    },
    mounted() {
        this.stores = JSON.parse(localStorage.getItem('stores'));

        let stores_app_tmp = JSON.parse(localStorage.getItem('stores_app'));

        if(stores_app_tmp) {
            this.stores_app = stores_app_tmp
        }
    }
}

</script>
<style lang='scss'>
   @import url('https://fonts.googleapis.com/css?family=Poppins:400,600,700|Work+Sans:300,400,700,900');

    #background {
        height: 100vh;
        background-size: cover !important;
        background-position: center!important;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .block {
        background-color: #eee;
        padding: 20px;
        text-align: center;
        cursor: pointer;
        opacity: 0.8;
        height: 100%;
        border-radius: 5px;
        font-weight: bold;
    }

    .block:hover {
        background-color: #ccc;
    }

    .block_app {
        background-color: #5bc9f4;
        padding: 20px;
        text-align: center;
        cursor: pointer;
        opacity: 0.8;
        height: 100%;
        border-radius: 5px;
        font-weight: bold;
    }

    .block_app:hover {
        background-color: #4ab8d3;
    }

    .block-img {
        opacity: 0.7;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    @media (max-width: 500px) {
        #container {
            height: 100% !important;
        }
        .box{
            padding-top: 15px !important;
        }
    }

    .box {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
        padding-top: calc(50vh - 88.5px);
    }

    #body_sub {
        background-image: url('../../public/acompanhar.jpg') !important;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        height: 100vh;
        overflow-y: scroll;
    }
</style>
